import { render } from "./PersonTwoFactorModal.vue?vue&type=template&id=70c2425d&scoped=true"
import script from "./PersonTwoFactorModal.vue?vue&type=script&lang=js"
export * from "./PersonTwoFactorModal.vue?vue&type=script&lang=js"

import "./PersonTwoFactorModal.vue?vue&type=style&index=0&id=70c2425d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c2425d"]])

export default __exports__